export default "__VITE_ASSET__D2ucii1R__"